module.exports = {
  futureTransfer: require('./future-transfer'),
  futureFile: require('./future-file'),
  RemoteTransfer: require('./remote-transfer'),
  RemoteFile: require('./remote-file')
};